import type { EmailCodeSent } from '@chukua/common';
import { api } from '../../../../shared/shared.api';

/** Emails a code to the signed-in user's own address; email codes stay off until it comes back. A test deployment returns the code instead. */
export function startEmailOtp(): Promise<EmailCodeSent> {
  return api<EmailCodeSent>('/auth/email-otp/enable', { method: 'POST' });
}

/** `recoveryCodes` is empty when the authenticator app was already on: the saved set still stands. */
export function confirmEmailOtp(code: string): Promise<{ recoveryCodes: string[] }> {
  return api<{ recoveryCodes: string[] }>('/auth/email-otp/enable/verify', { method: 'POST', body: JSON.stringify({ code }) });
}

export function disableEmailOtp(password: string): Promise<void> {
  return api<void>('/auth/email-otp/disable', { method: 'POST', body: JSON.stringify({ password }) });
}
